import { IonSkeletonText } from "@ionic/react";
import { FormattedMessage } from "react-intl";
import { SwiperSlide } from "swiper/react";

import styles from "@components/drive/Drive.module.css";
import CardSlides from "@components/layout/CardSlides";
import loaderStyles from "@components/loaders/LoaderStyles.module.css";
import Heading2 from "@components/typography/Heading2";

const DriveLoader = () => (
  <div>
    <div className={styles.header}>
      <div>
        <div className={styles.titleAndSearch}>
          <div className={styles.noWrap}>
            <Heading2>
              <FormattedMessage id="pages.drive.recentFiles" />
            </Heading2>
          </div>
          <IonSkeletonText animated className={loaderStyles.skeletonSearch} />
        </div>
        <div className={styles.showMobile + " " + styles.recentSlides}>
          <CardSlides itemCount={4}>
            {Array.from(Array(4)).map(() => (
              <SwiperSlide key={Math.random()}>
                <IonSkeletonText animated className={loaderStyles.skeletonDocument} key={Math.random()} />
              </SwiperSlide>
            ))}
          </CardSlides>
        </div>
        <div className={styles.headerRecentFiles}>
          {Array.from(Array(4)).map(() => (
            <IonSkeletonText animated className={loaderStyles.skeletonDocument} key={Math.random()} />
          ))}
        </div>
      </div>
      <IonSkeletonText animated className={loaderStyles.skeletonUploadDoc} />
    </div>
    <div className={styles.documents}>
      <Heading2>
        <FormattedMessage id="pages.drive.documents" />
      </Heading2>
      <div className={styles.folders}>
        {Array.from(Array(6)).map(() => (
          <IonSkeletonText animated className={loaderStyles.skeletonFolder} key={Math.random()} />
        ))}
      </div>
    </div>
  </div>
);

export default DriveLoader;
